"use client";
import { useLandingAnalytics } from "../hooks/use-landing-analytics";
export function AnalyticsConsent() {
  const { visible, choose, blocked } = useLandingAnalytics();
  return visible ? (
    <aside
      className="analytics-consent"
      aria-labelledby="analytics-choice-title"
    >
      <div>
        <strong id="analytics-choice-title">
          Help us understand what connects.
        </strong>
        <p>
          Allow optional usage analytics on our public pages? We count visits,
          previews and signups with a temporary session. Your private BLOX, name
          and email are never included. Event data is kept for 90 days.
        </p>
        {blocked && <p>Your browser privacy preference prevents collection.</p>}
      </div>
      <div>
        <button className="button secondary" onClick={() => choose(false)}>
          No thanks
        </button>
        <button
          className="button secondary"
          onClick={() => choose(true)}
          disabled={blocked}
        >
          Allow analytics
        </button>
      </div>
    </aside>
  ) : null;
}
export function PrivacyChoices() {
  return (
    <button
      className="privacy-choices"
      onClick={() => window.dispatchEvent(new Event("lb-privacy-choice"))}
    >
      Privacy choices
    </button>
  );
}
